import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  Box,
  Stack,
} from "@mui/material";

export default function RecalculateInvoiceModal({ open, onClose, onConfirm, invoice }) {
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="recalculate-invoice-dialog-title"
      aria-describedby="recalculate-invoice-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="recalculate-invoice-dialog-title">
        <Typography variant="h3">Re-calculate Invoice</Typography>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} mt={1}>
          {invoice && (
            <Typography variant="body1" paragraph>
              Re-calculating invoice <strong>'{invoice.name || invoice.invoice_num || "Unnamed Invoice"}'</strong>.
            </Typography>
          )}

          <Box
            sx={{
              p: 2,
              borderRadius: 1,
              backgroundColor: "action.hover",
            }}
          >
            <Typography variant="body2" paragraph>
              This will recheck and recalculate the invoice totals based on the current linked calendar events and settings.
            </Typography>
            <Typography variant="body2" color="text.secondary">
              The system will review all associated events and update the invoice totals, line items, and amounts accordingly.
            </Typography>
          </Box>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          color="primary"
          variant="contained"
        >
          Re-calculate
        </Button>
      </DialogActions>
    </Dialog>
  );
}


